# Open the age gate modal if the user hasn't agreed to it before
import { mountOnBody } from 'library/services/helpers'
import AgeGate, { LS_KEY } from 'library/components/globals/modals/age-gate'
ZIP_LS_KEY = 'ageGateZip'

export default ({ route, store }, inject) ->

	# On the CBD or Hemp sites, only show the age gate for certain paths
	gatedPaths = store.state.globals.siteGate?.gatedPaths || []
	gatedPaths = gatedPaths.map ({ path }) -> path
	if process.env.CMS_SITE in ['hemp', 'cbd'] and
		route.path not in gatedPaths
	then return

	# Set the age gate zip to vuex if we already know it
	store.commit 'customer/setAgeGateZip', getLocalStorageZip()

	# Create a global promise to store whether the age gate was passed. This also
	# runs the check and spawns the age gate modal if they haven't passed.
	inject 'ageGatePassed', new Promise (resolve) ->

		# Has the user met the necessary requirements
		hasPassed = !!localStorage.getItem(LS_KEY) &&
			!!store.state.customer.ageGateZip

		# Open if the user hasn't seen it before or listen for it to be passed
		if hasPassed then resolve()
		else (await mountOnBody(AgeGate)).$on 'passed', -> resolve()

	# Sync the customer's age gate zip to localStorage
	store.watch ((state) -> state.customer.ageGateZip)
	, ((zip) -> localStorage.setItem ZIP_LS_KEY, zip if zip)
	, immediate: true

# Get the user's zip from localStorage
getLocalStorageZip = -> switch

	# Current place zip is stored
	when zip = localStorage.getItem ZIP_LS_KEY then zip

	# Old way zip was stored
	when info = localStorage.getItem 'user-info:grassdoor'
		[zip, suppported] = info.split ','
		return zip
